"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDatePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DatePicker = _interopRequireDefault(require("../DatePicker"));

var _context = require("../../context");

var _constants = require("../../constants");

var _utils = require("../../utils");

var _useFetchReferencesSearchCalendarDuration = require("../../hooks/useFetchReferencesSearchCalendarDuration");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormDatePicker = function FormDatePicker(_ref) {
  var name = _ref.name,
      className = _ref.className,
      searchType = _ref.searchType,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$isOpenInitial = _ref.isOpenInitial,
      isOpenInitial = _ref$isOpenInitial === void 0 ? false : _ref$isOpenInitial,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
      setBodyLocked = _ref.setBodyLocked;

  var _useField = (0, _formik.useField)(name),
      _useField2 = _slicedToArray(_useField, 3),
      value = _useField2[0].value,
      error = _useField2[1].error,
      _useField2$ = _useField2[2],
      setValue = _useField2$.setValue,
      setError = _useField2$.setError;

  var _useField3 = (0, _formik.useField)(_constants.FIELD_NAMES.destination),
      _useField4 = _slicedToArray(_useField3, 1),
      destinationValue = _useField4[0].value;

  var _useField5 = (0, _formik.useField)(_constants.FIELD_NAMES.departure),
      _useField6 = _slicedToArray(_useField5, 1),
      departureValue = _useField6[0].value;

  var _useField7 = (0, _formik.useField)(_constants.FIELD_NAMES.tourists),
      _useField8 = _slicedToArray(_useField7, 1),
      touristsValue = _useField8[0].value;

  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      isMobile = _useCigarette$state.isMobile,
      isWizard = _useCigarette$state.isWizard,
      steps = _useCigarette$state.steps,
      dispatch = _useCigarette.dispatch;

  var _useState = (0, _react.useState)(!isMobile),
      _useState2 = _slicedToArray(_useState, 2),
      hide = _useState2[0],
      setHide = _useState2[1];

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      previousSearchType = _useState4[0],
      setPreviousSearchType = _useState4[1];

  var _useFetchReferencesSe = (0, _useFetchReferencesSearchCalendarDuration.useFetchReferencesSearchCalendarDuration)(),
      searchCalendarDuration = _useFetchReferencesSe.searchCalendarDuration,
      changeSearchCalendarDurationParams = _useFetchReferencesSe.changeSearchCalendarDurationParams;

  var onPanelChange = (0, _react.useCallback)(function (value) {
    if (value.left && departureValue !== null && departureValue !== void 0 && departureValue.id && destinationValue !== null && destinationValue !== void 0 && destinationValue.value) {
      changeSearchCalendarDurationParams(value.left, destinationValue.value, departureValue.id, touristsValue.adults, searchType, touristsValue.kids);
    }
  }, [departureValue === null || departureValue === void 0 ? void 0 : departureValue.id, touristsValue.adults, searchType, destinationValue === null || destinationValue === void 0 ? void 0 : destinationValue.value, touristsValue.kids]); // Изменяем цены на календаре, если поменяли состав туристов и тд.

  (0, _react.useEffect)(function () {
    if (value !== null && value !== void 0 && value.left.date) {
      onPanelChange({
        left: value === null || value === void 0 ? void 0 : value.left.date,
        right: value === null || value === void 0 ? void 0 : value.right.date
      });
    }
  }, [onPanelChange]);
  var openInWizard = (0, _utils.isDatepickerStep)(steps) || undefined;
  var openCalendar = !isMobile && !!error;
  var isOpen = openInWizard || openCalendar || isOpenInitial;
  var hideDatePicker = variant !== 'hotel' && (!isWizard && hide || isWizard && !openInWizard && !(0, _utils.afterDatepickerStep)(steps));
  var onClose = (0, _react.useCallback)(function () {
    setError(undefined);
  }, [setError]);

  var onChange = function onChange(newValue) {
    setValue(newValue);

    if (isWizard) {
      dispatch((0, _context.addStep)(_constants.FIELD_NAMES.tourists));
    }
  };

  (0, _react.useEffect)(function () {
    if (hide && destinationValue) {
      setHide(false);
    }
  }, [destinationValue]);
  (0, _react.useEffect)(function () {
    if (value && previousSearchType && previousSearchType !== searchType && variant !== 'hotel') {
      setValue(undefined);
    }

    if (previousSearchType !== searchType) {
      setPreviousSearchType(searchType);
    }
  }, [searchType]);

  if (hideDatePicker) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(FormDatePickerContainer, {
    $isWizard: isWizard,
    $isMobile: isMobile,
    $isTouristsStep: (0, _utils.isTouristsStep)(steps)
  }, /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], {
    onPanelChange: onPanelChange,
    onChange: onChange,
    isMobile: isMobile,
    isWizard: isWizard,
    setBodyLocked: setBodyLocked,
    initialValue: value,
    className: className,
    searchCalendarDuration: searchCalendarDuration,
    open: isOpen,
    onClose: onClose,
    searchType: searchType,
    variant: variant,
    departureId: departureValue === null || departureValue === void 0 ? void 0 : departureValue.id,
    placeId: destinationValue === null || destinationValue === void 0 ? void 0 : destinationValue.value,
    isOpenInitial: isOpenInitial,
    isWhiteLabel: isWhiteLabel
  }));
};

exports.FormDatePicker = FormDatePicker;

var FormDatePickerContainer = _styledComponents["default"].div.withConfig({
  displayName: "FormDatePicker__FormDatePickerContainer",
  componentId: "sc-fi4c1i-0"
})(["min-width:", ";", ";"], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile ? '100%' : '340px';
}, function (_ref3) {
  var $isTouristsStep = _ref3.$isTouristsStep,
      $isMobile = _ref3.$isMobile;
  return $isTouristsStep || $isMobile ? "order: 1;" : '';
});